import { useMemo } from 'react';

import { DEFAULT_TYPEAHEAD_QUERY_LIMIT, DEFAULT_TYPEAHEAD_SORTING } from '../../../constants';

export const useTemplatesVariables = (search: string) =>
  useMemo(
    () => ({ search, pagination: DEFAULT_TYPEAHEAD_QUERY_LIMIT, sort: DEFAULT_TYPEAHEAD_SORTING }),
    [search],
  );
